const formatRenewalStatusText = (status) => {
  return status === "now"
    ? "Renew"
    : status === "surcharge"
    ? "Surcharge"
    : status === "never"
    ? "Stop"
    : status === "on_hold"
    ? "On hold"
    : status === "later"
    ? "Ungranted"
    : status === "finished"
    ? "Finished"
    : status === "manual"
    ? "Verifying"
    : status === "client_is_responsible"
    ? "Client responsible"
    : status === "dead"
    ? "Expired"
    : "";
};

export { formatRenewalStatusText };
